// @ts-nocheck

import { request } from '../../context';
import type { ApiOptions } from '../../context';
import type { BaseResponseListAiAgentFoundResponse } from '../../types';

/**
 * 查询所有智能体列表
 *
 * @export
 * @tags ai-agent-controller
 * @link [GET] /aiAgents/list
 */
export function getAiAgentsList(): Promise<BaseResponseListAiAgentFoundResponse>;
export function getAiAgentsList(
    options: ApiOptions<never, never>
): Promise<BaseResponseListAiAgentFoundResponse>;
export function getAiAgentsList(
    options?: ApiOptions<never, never>
): Promise<BaseResponseListAiAgentFoundResponse> {
    return request<never, never, never>('/aiAgents/list', {
        ...options,
        method: 'get',
        __$requestCalleeName: 'getAiAgentsList',
    });
}

export const meta = [{ tags: ['ai-agent-controller'], path: '/aiAgents/list', method: 'get' }];
